export type UsageStatus =
  | "active"
  | "subscription_ending"
  | "expired"
  | "quota_reached";

export const normalizeUsageStatus = (
  rawStatus?: string | null,
): UsageStatus | null => {
  if (!rawStatus) return null;
  const normalized = rawStatus.toLowerCase();
  if (normalized === "active") return "active";
  if (normalized === "subscription_ending") return "subscription_ending";
  if (normalized === "expired") return "expired";
  if (normalized === "quota_reached") return "quota_reached";
  return null;
};

export const resolveUsageStatus = ({
  rawUsageStatus,
  usageSummaryStatus,
  displayBudgetMicrousd,
  displayUsedMicrousd,
  isBillingExpired,
  isBillingCanceled,
}: {
  rawUsageStatus?: string | null;
  usageSummaryStatus?: string | null;
  displayBudgetMicrousd?: number | string | null;
  displayUsedMicrousd?: number | string | null;
  isBillingExpired: boolean;
  isBillingCanceled: boolean;
}): UsageStatus => {
  const fromSummary = normalizeUsageStatus(rawUsageStatus);
  const isSummaryExpired =
    String(usageSummaryStatus || "").toUpperCase() === "EXPIRED";

  if (isBillingExpired || isSummaryExpired || fromSummary === "expired") {
    return "expired";
  }

  if (fromSummary) {
    return fromSummary;
  }

  const budget = Number(displayBudgetMicrousd || 0);
  const used = Number(displayUsedMicrousd || 0);
  const quotaReached = budget > 0 && used >= budget;

  if (quotaReached) return "quota_reached";
  if (isBillingCanceled) return "subscription_ending";
  return "active";
};
